module.exports = __webpack_public_path__ + "img/logo.9591bd81.png";